import ListItem, { ListItemIcon, ListItemText } from './Item/index.ts';
import List from './List.tsx';

const EnhancedList = Object.assign(List, {
  Item: ListItem
});

export default EnhancedList;
export { ListItem, ListItemIcon, ListItemText };
export type { ListProps } from './List.tsx';
